import { z } from 'zod'

export const EVAL_TABS = ['evaluation', 'cases'] as const

export type EvalTab = (typeof EVAL_TABS)[number]

export const EVAL_VALIDATE_VIEW = 'validate' as const
export const EVAL_CREATE_VIEW = 'create' as const

export type EvalView = typeof EVAL_VALIDATE_VIEW | typeof EVAL_CREATE_VIEW

export type EvalsSearchParams = {
  tab: EvalTab
  view?: EvalView
  baseId?: string
  candId?: string
}

const optionalToken = (value: string | undefined): string | undefined =>
  value ? value : undefined

/**
 * Bookmarks still use run / compare / suites / validate. Collapse those onto
 * Evaluation and Cases so old links keep working.
 */
export function normalizeEvalsSearch(raw: {
  tab?: string
  view?: string
  baseId?: string
  candId?: string
}): EvalsSearchParams {
  const baseId = optionalToken(raw.baseId)
  const candId = optionalToken(raw.candId)
  const pair = {
    ...(baseId ? { baseId } : {}),
    ...(candId ? { candId } : {}),
  }
  const tab = raw.tab

  if (tab === 'validate') {
    return { tab: 'cases', view: EVAL_VALIDATE_VIEW, ...pair }
  }
  if (tab === 'cases') {
    return {
      tab: 'cases',
      ...(raw.view === EVAL_VALIDATE_VIEW ? { view: EVAL_VALIDATE_VIEW } : {}),
      ...pair,
    }
  }
  if (tab === 'suites') {
    return { tab: 'cases', ...pair }
  }
  return {
    tab: 'evaluation',
    ...(raw.view === EVAL_CREATE_VIEW ? { view: EVAL_CREATE_VIEW } : {}),
    ...pair,
  }
}

export const evalsSearchSchema = z
  .object({
    tab: z.string().optional(),
    view: z.string().optional(),
    baseId: z.string().optional(),
    candId: z.string().optional(),
  })
  .transform((raw) => normalizeEvalsSearch(raw))
